import { Tabs } from '@bfe/moly';
import { useMemo, useState } from 'react';
import { RanksTabkey } from './types';
import { VerifiedReport } from '@/containers/home/ranks/verified-report';
import { HackerAddress } from './hacker-address';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';
import { useFm, useScreenType } from '@web3/base-hooks';

import Bounty from './Bounty';

export const Ranks = () => {
  const fm = useFm();
  const { isMobile } = useScreenType();
  const [currentTab, setCurrentTab] = useState<RanksTabkey>(
    RanksTabkey.BOUNTY_LEADERBOARD
  );

  const tabList = useMemo(
    () => [
      {
        key: RanksTabkey.BOUNTY_LEADERBOARD,
        label: fm('bountyLeaderboard'),
        children: <Bounty />,
      },
      {
        key: RanksTabkey.HACKER_ADDRESS,
        label: fm('hackerAddress'),
        children: <HackerAddress />,
      },
      {
        key: RanksTabkey.VERIFYREPORTS,
        label: fm('verifiedReports'),
        children: <VerifiedReport />,
      },
    ],
    []
  );

  const handleChangeTab = (value: RanksTabkey) => {
    if (value === RanksTabkey.HACKER_ADDRESS) {
      scTrack(Event.HackbountyUserClick, {
        page_name: Page.HackbountyHomePage,
        button_name: 'HackerAddress',
      });
    }

    if (value === RanksTabkey.VERIFYREPORTS) {
      scTrack(Event.HackbountyUserClick, {
        page_name: Page.HackbountyHomePage,
        button_name: 'VerifiedReports',
      });
    }
    setCurrentTab(value);
  };

  return (
    <div className="max-w-[1200px] min-[768px]:mx-auto min-[768px]:mt-[84px] mt-10 min-[768px]:pb-20 pb-10 max-[768px]:px-4">
      <Tabs
        // className="md:h-[664px] h-[844px]"
        size={isMobile ? 'm' : 'xl'}
        items={tabList}
        activeKey={currentTab}
        onChange={handleChangeTab}
      />
    </div>
  );
};
